import { Card, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Workflow, Zap, Search, Cpu } from "lucide-react";

const services = [
  {
    icon: Zap,
    title: "GoHighLevel Setup & Management",
    description:
      "Your plug-and-play business operating system. Complete CRM setup, pipeline build, lead capture forms, booking calendar, automations, email/SMS templates, AI lead responder, and reputation management.",
  },
  {
    icon: Workflow,
    title: "Business Automation System",
    description:
      "Automate your entire business to eliminate busywork. Lead intake, client onboarding, appointment workflows, sales pipelines, email/SMS sequences, team handoffs, task automation, AI chatbots, and custom integrations tailored to your needs.",
  },
  {
    icon: Search,
    title: "Automation Audit",
    description:
      "Comprehensive review of your current systems, missed automation opportunities, lead leakage, customer journey gaps, and tech stack problems. Get a clear roadmap for optimization and growth.",
  },
  {
    icon: Cpu,
    title: "Local LLM Setup",
    description:
      "Deploy private, on-premise AI language models for your business. Maintain complete data privacy while leveraging AI for customer support, content generation, analysis, and automation without monthly API costs.",
  },
];

export function Services() {
  return (
    <section id="services" className="bg-gray-900 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <h2 className="mb-4 text-white">Our Offers</h2>
          <p className="text-gray-400">
            Comprehensive automation solutions designed to scale your business
            and eliminate manual work
          </p>
        </div>

        <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="flex flex-col border-gray-800 bg-gray-950 transition-colors hover:border-blue-500/50"
              >
                <CardHeader className="flex flex-1 flex-col">
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg border border-blue-500/20 bg-gradient-to-br from-blue-500/10 to-emerald-500/10">
                    <Icon className="h-6 w-6 text-blue-400" />
                  </div>
                  <CardTitle className="text-white">{service.title}</CardTitle>
                  <CardDescription className="flex-1 pb-4 text-gray-400">
                    {service.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
